import React from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const Modal = ({
  children,
  onClose,
}: {
  children: React.ReactNode
  onClose: () => void
}) => {
  return createPortal(<ModalBackdrop onClick={onClose}>{children}</ModalBackdrop>, document.body)
}

export const ModalContent = ({
  children,
  onClick,
  maxWidth,
}: {
  children: React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
  maxWidth?: string
}) => {
  return (
    <ModalContentStyled
      onClick={onClick ? onClick : (e) => e.stopPropagation()}
      maxWidth={maxWidth}
    >
      {children}
    </ModalContentStyled>
  )
}

export const ModalContentStyled = styled.div<{ maxWidth?: string }>`
  --padding: 1.25rem;
  min-width: 400px;
  background-color: ${tokens.surface.raised};
  border: 1px solid ${tokens.border.hairline};
  border-radius: ${tokens.radius.card};
  box-shadow: ${tokens.shadow.card};
  color: ${tokens.text.primary};
  display: flex;
  flex-direction: column;
  max-height: 85vh;
  max-width: ${(props) => props.maxWidth ?? '100%'};
`

export const ModalHeader = styled.div`
  padding: var(--padding);
  border-bottom: 1px solid ${tokens.border.hairline};
`

export const ModalBody = styled.div`
  padding: var(--padding);
  flex: 1;
  overflow-y: auto;
`

export const ModalFooter = styled.div`
  padding: var(--padding);
  border-top: 1px solid ${tokens.border.hairline};
  display: flex;
  justify-content: flex-end;
  gap: ${tokens.space.sm};
`

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(2px);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`
